import { render, staticRenderFns } from "./TemplateLoader.vue?vue&type=template&id=e9732ac8&scoped=true&"
import script from "./TemplateLoader.vue?vue&type=script&lang=js&"
export * from "./TemplateLoader.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLoader.vue?vue&type=style&index=0&id=e9732ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9732ac8",
  null
  
)

export default component.exports